$shm_hitalama_map_widget_float_settings_widget_page $shm_hitalama_map_widget_float_settings
	Page $shm_hitalama_map_widget_page
		widget <= controlled_widget
	Message $mol_text
		text \Настройки виджета
	style *
		^
		display <= style_display \flex
